import React from 'react'
import * as S from './styles'

import type { BorderRadius, SpacingStack } from 'types'

interface Props {
  children: React.ReactNode
  padding?: number | string
  gap?: SpacingStack
  borderRadius?: BorderRadius
  backgroundColor?: string
  flexDirection?: string
}

export const BoxSection = ({ children, ...props }: Props) => {
  return <S.BoxSection {...props}>{children}</S.BoxSection>
}
